export default "__VITE_PUBLIC_ASSET__cbac9d1e__"